import { useEffect } from 'react';
import { useParams } from 'react-router';
import CorralForm from '../../components/corrales/CorralForm';
import { useCorralesStore, type ActualizarCorral } from '../../stores/corrales/corrales.store';

const EditarCorral = () => {
  const paramId = useParams<{ id: string }>().id ?? '';
  const id = Number(paramId);
  const {
    current: corral,
    actualizar,
    cargarPorId,
    desactivar,
    activar
  } = useCorralesStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarCorral) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <CorralForm
      corral={corral}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarCorral;
